import {setLoadingStateDispatch} from "../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../context/SnackBarContext";
import {HttpClient} from "../service/httpClient/HttpClient";


export class BaseService {

    constructor(token, loading, snackbar) {
        this.token = token;
        this.loading = loading;
        this.snackbar = snackbar;

        this.httpClient = new HttpClient()
    }

    showLoading() {
        this.loading(setLoadingStateDispatch(true))
    }

    hideLoading() {
        this.loading(setLoadingStateDispatch(false))
    }

    showSuccessMessage(message) {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, message))
    }

    showErrorMessage(message) {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, message))
    }

    showWarningMessage(message) {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
    }

    getDefaultHeader() {
        return this.httpClient.prepareUserAccessHeader(this.token)
    }
}